/* Cuisine Inspirante — rappel d'achat + barre mobile (sections ci-rc-cta)
   Aucun second formulaire : les boutons déclenchent le vrai bouton
   « Ajouter au panier » du thème, donc la variante sélectionnée, la quantité,
   le panier tiroir, les ruptures et les erreurs restent gérés par le thème. */
(function () {
  if (window.__ciRcCtaInit) return;
  window.__ciRcCtaInit = true;

  function init() {
    var roots = document.querySelectorAll('[data-ci-rc-cta]');
    if (!roots.length) return;

    var mainSubmit =
      document.querySelector('.product__info-wrapper product-form button[type="submit"]') ||
      document.querySelector('product-form button[type="submit"][id^="ProductSubmitButton-"]');
    var mainForm = mainSubmit ? mainSubmit.closest('form') : null;
    var mainProductForm = mainSubmit ? mainSubmit.closest('product-form') : null;
    var mainInfo =
      document.querySelector('.product__info-wrapper') ||
      (mainSubmit && mainSubmit.closest('section, .shopify-section'));
    var mainPrice =
      document.querySelector('.product__info-wrapper [id^="price-"]') ||
      document.querySelector('.product__info-wrapper .price');
    var variantInput = mainForm ? mainForm.querySelector('input[name="id"]') : null;
    var errorWrap = mainProductForm ? mainProductForm.querySelector('.product-form__error-message-wrapper') : null;

    var ctaButtons = document.querySelectorAll('[data-ci-rc-add]');
    var priceTargets = document.querySelectorAll('[data-ci-rc-price]');
    var variantTargets = document.querySelectorAll('[data-ci-rc-variant]');
    var statusTargets = document.querySelectorAll('[data-ci-rc-status]');
    var variantMap = {};
    roots.forEach(function (r) {
      var s = r.querySelector('script[data-ci-rc-variants]');
      if (s) { try { Object.assign(variantMap, JSON.parse(s.textContent)); } catch (e) {} }
    });

    function setStatus(msg) {
      statusTargets.forEach(function (el) { el.textContent = msg || ''; });
    }

    function sync() {
      if (!mainSubmit) {
        ctaButtons.forEach(function (b) { b.hidden = true; });
        return;
      }
      var disabled = mainSubmit.disabled || mainSubmit.getAttribute('aria-disabled') === 'true';
      var loading = mainSubmit.classList.contains('loading');
      var labelEl = mainSubmit.querySelector('span');
      var label = (labelEl ? labelEl.textContent : mainSubmit.textContent).trim();
      ctaButtons.forEach(function (b) {
        var txt = b.querySelector('[data-ci-rc-label]');
        if (txt && label) txt.textContent = label;
        b.disabled = !!mainSubmit.disabled;
        b.setAttribute('aria-disabled', disabled ? 'true' : 'false');
        b.classList.toggle('is-loading', loading);
        b.setAttribute('aria-busy', loading ? 'true' : 'false');
      });
      if (mainPrice) {
        var html = mainPrice.innerHTML;
        priceTargets.forEach(function (el) { el.innerHTML = html; });
      }
      if (variantInput && variantMap[variantInput.value] !== undefined) {
        variantTargets.forEach(function (el) {
          el.textContent = variantMap[variantInput.value];
          el.hidden = !variantMap[variantInput.value];
        });
      }
    }

    if (mainSubmit) {
      new MutationObserver(sync).observe(mainSubmit, { attributes: true, childList: true, subtree: true, characterData: true });
    }
    if (mainPrice) {
      new MutationObserver(sync).observe(mainPrice, { childList: true, subtree: true, characterData: true });
    }
    if (variantInput) variantInput.addEventListener('change', sync);
    if (mainForm) mainForm.addEventListener('change', function () { setTimeout(sync, 50); });
    if (errorWrap) {
      new MutationObserver(function () {
        if (!errorWrap.hasAttribute('hidden')) {
          var m = errorWrap.querySelector('.product-form__error-message');
          setStatus(m ? m.textContent : '');
        } else {
          setStatus('');
        }
      }).observe(errorWrap, { attributes: true, childList: true, subtree: true });
    }
    sync();

    ctaButtons.forEach(function (b) {
      b.addEventListener('click', function () {
        if (!mainSubmit || mainSubmit.disabled || mainSubmit.getAttribute('aria-disabled') === 'true') return;
        setStatus('');
        mainSubmit.click();
      });
    });

    document.querySelectorAll('[data-ci-rc-back]').forEach(function (a) {
      a.addEventListener('click', function (e) {
        if (!mainInfo) return;
        e.preventDefault();
        var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        mainInfo.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' });
        var focusable = mainInfo.querySelector('fieldset input, select, .quantity__input, button[type="submit"]');
        if (focusable) setTimeout(function () { focusable.focus({ preventScroll: true }); }, reduce ? 0 : 450);
      });
    });

    /* Barre mobile : visible une fois le bouton principal dépassé,
       masquée quand le rappel final ou le pied de page est à l'écran.
       Option « dès l'arrivée » (data-ci-rc-sticky-early) : visible aussi tant que le bouton principal est plus bas. */
    var sticky = document.querySelector('[data-ci-rc-sticky]');
    if (sticky && mainSubmit && 'IntersectionObserver' in window) {
      var pastMain = false, nearEnd = false;
      var early = sticky.hasAttribute('data-ci-rc-sticky-early');
      var update = function () {
        var show = pastMain && !nearEnd;
        sticky.classList.toggle('is-visible', show);
        sticky.setAttribute('aria-hidden', show ? 'false' : 'true');
        sticky.querySelectorAll('a, button').forEach(function (el) { el.tabIndex = show ? 0 : -1; });
      };
      new IntersectionObserver(function (entries) {
        entries.forEach(function (en) { pastMain = !en.isIntersecting && (early || en.boundingClientRect.top < 0); });
        update();
      }).observe(mainSubmit);
      var endEls = [document.querySelector('[data-ci-rc-cta-panel]'), document.querySelector('footer, .footer')].filter(Boolean);
      var visibleEnds = new Set();
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) { en.isIntersecting ? visibleEnds.add(en.target) : visibleEnds.delete(en.target); });
        nearEnd = visibleEnds.size > 0;
        update();
      });
      endEls.forEach(function (el) { io.observe(el); });
      update();
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
